import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "../../../../blocks/CarouselItem";

import {BarChart} from "d3plus-react";
import {removeDecimalsIfNotNeeded, calculateDomain} from "../../../../../helpers/formatters";
import MiniLegend from "../../../../items/MiniLegend";
import Source from "../../../../items/Source";

class LaborMarketDemand extends Component {

  render() {
    const {clustersData, selectedCluster, width} = this.props;

    const selectedClusterID = selectedCluster.id;
    const averageClusterID = 14;
    const clustersIds = [selectedClusterID, averageClusterID];

    if (!clustersData){
      return '';
    }

    const filteredData = clustersData.filter(cd => clustersIds.indexOf(cd.cluster_id) > -1);

    const colors = filteredData.map(d => ({color: d.color, label: d.cluster_name}));

    const fields = {
      'share_of_positive_job_growth_2018_30': 'Net job growth, %',
      'employment_rate_change_2018_30_in_share': 'Employment rate change, p.p.',
      'working_age_population_change_2018_30_in_thousands': 'Working-age population change, 2018-30, %',
    };

    let barW = width < 1000 ? 30 : 50;
    barW = width < 768 ? 20 : 50;

    const finalData = [];
    let xMax = 0;
    let xMin = 0;
    let value;
    Object.keys(fields).forEach(f => {
      filteredData.forEach(fd => {
        value = fd[f];
        finalData.push({cluster_id: fd.cluster_id, cluster_name: fd.cluster_name, property: fields[f], value: value.toFixed(4), color: fd.color});
        xMax = xMax < value ? value : xMax;
        xMin = xMin > value ? value:xMin;
      });
    });

    const chartConfig = {
      data: finalData,
      groupBy: ["cluster_name"],
      legend: false,
      height: 400,
      discrete: "x",
      duration: 0,
      x: "property",
      y: "value",
      tooltipConfig: {
        body: d => `<div>${d.property}: ${removeDecimalsIfNotNeeded(d.value * 100)}%</div>`
      },
      xConfig: {
        title: false,
        tickSize: 0,
        barConfig: {
          stroke: "#666",
          strokeWidth: 1
        }
      },
      yConfig: {
        title: false,
        tickSize: 0,
        tickFormat: x => `${Math.round(x*100)}%`,
        domain: calculateDomain(xMin, xMax, true),
        gridConfig: {
          stroke: d => Math.abs(d.id) === 0 ? "#666" : "#fff",
          strokeWidth: 1
        },
        barConfig: {
          stroke: "#666",
          strokeWidth: 1
        },
        shapeConfig: {
          stroke: "#efefef",
          strokeWidth: 1
        }
      },
      shapeConfig: {
        fill: d => d.color,
        Bar: {
          width: barW,
          label: d => {
            const sign = (d.property === "Employment rate change, p.p.")?'p.p.':'%';
            return `${removeDecimalsIfNotNeeded(d.value * 100)}${sign}`;
          },
          labelBounds: (d, ix, s) => {
            const w = 100;
            const h = !s.height ? 50 : s.height;
            let y = d.value < 0 ? h : -h-25;
            return {
              width: w,
              height: 50,
              x: -w/2,
              y: y,
              value: d.value
            };
          },
          labelConfig: {
            textAnchor: (d) => "middle",
            fontColor: () => "#000",
            fontFamily: () => "'FOW Theinhardt', sans-serif",
            fontSize: () => 12,
            fontWeight: () => 400
          }
        }
      },
      legendTooltip: {
        body: "",
        footer: "",
      },
      groupPadding: 5,
      barPadding: 2,
      on: {"click.legend": () => {}}
    };
    return (
      <CarouselItem title="Potential labor demand changes 2018-2030">
        <div className="fow-col fow-col-1">
          <MiniLegend colors={colors} />
          <div className="fow-col-1-2-center-chart">
            <BarChart config={chartConfig} />
          </div>
          <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis" />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    clustersData: state.db.data.dimensions.clusters ? state.db.data.dimensions.clusters : false,
    selectedCluster: state.settings.map["Clusters"],
    width: state.settings.window.width
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LaborMarketDemand);
